import { React, useAPI } from 'mcelroy-lib'
import { TablePage, useUserContext } from 'mcelroy-components'

/*
    Page to list distributor locations that this user can see
    Employees can see all locations but only admins can edit
    Distributors can see their locations and admins can edit
*/
export function DistributorLocationsPage() {
    const { user: currentUser } = useUserContext()

    // API distributor  location list query
    const { loading, data } = useAPI(`
        query{
            distributorLocations{
                id
                distributorName
                customerNbr
                city
                state
                phone
            }
        }
    `)

    // Table columns
    const columns = [
        { title: 'Distributor Name', name: 'distributorName' },
        { title: 'Customer Number', name: 'customerNbr' },
        { title: 'City', name: 'city' },
        { title: 'State', name: 'state' },
        { title: 'Phone', name: 'phone' }
    ]

    // Page display
    const options = {
        keyColumn: 'id',
        limit: 100
    }
    const actions = []
    if (currentUser.isUserAdmin) {
        actions.push({ label: 'Create Distributor', to: '/create_distributor' })
        options.rowClickTo = '/distributors/:id'
    }
    return (
        <TablePage columns={columns} data={data?.distributorLocations} loading={loading}
            options={options}
            actions={actions}
        />
    )
}
